import React from "react"
import * as styles from "./style.module.css"

export default ({ link, icon, color }) => (
  <a href={link} style={{ color: color || "#333333" }} className={styles.link}>
    <i className={icon} />
  </a>
)
